<template>
  <section class="ticket-section">
    <h1>
      {{ $t('ticket-section.key001') }}
    </h1>

    <div class="filter-section">
      <button
        v-for="category in categories"
        :key="category"
        :class="{
          'filter-button': true,
          active: currentCategory === category,
        }"
        @click="changeCategory(category)"
      >
        {{ category === TicketCategory.UNUSED ? $t('ticket-section.key003') : $t('ticket-section.key004') }}
      </button>
    </div>

    <div class="ticket-list" v-if="!empty">
      <div v-for="ticket in filteredTickets" :key="ticket.id" class="ticket-item">
        <div class="item-info">
          <img :src="ticket.image" alt="" />
          <div class="ticket-tag" :class="'type-' + ticket.type" v-if="ticket.typeText">
            {{ ticket.typeText }}
          </div>
          <div class="text">
            <p class="ticket" v-if="currentCategory === TicketCategory.UNUSED && ticket.quantity - ticket.used > 1">
              <img src="../../assets/img/member/tickets.svg" alt="" />
              {{ ticket.quantity - ticket.used }}
            </p>
            <p class="ticket" v-if="currentCategory === TicketCategory.EXPIRED && (ticket.used > 1 || (!ticket.valid && ticket.quantity > 1))">
              <img src="../../assets/img/member/tickets.svg" alt="" />
              {{ ticket.valid ? ticket.used : ticket.quantity }}
            </p>
            <h2 class="title">{{ ticket.title }}</h2>
            <h3>{{ ticket.shortDescription }}</h3>
          </div>
        </div>
        <button class="go-to" @click="goToUsage(ticket.id)">
          {{ $t('ticket-section.key005') }}
        </button>
      </div>
    </div>
    <div v-if="empty" class="empty">
      <h2>
        {{ $t('ticket-section.key006') }}
        <router-link :to="`/${currentLanguage}/member/serial-number/serial-number-default`">
          <span>{{ $t('ticket-section.key007') }}</span>
        </router-link>
      </h2>
    </div>
    <info-popup v-if="selectedTicket" :ticket="selectedTicket" @close-info-popup="closeInfoPopup" @update-tickets="fetchTickets"></info-popup>
  </section>
  <Loading v-show="loading"></Loading>
</template>

<script>
import InfoPopup from '@/components/memberCenter/InfoPopup.vue';
import { getUserBackpack } from '@/api/apiService';
import Loading from '@/components/Loading.vue';
import { mapState } from 'vuex';

const cloudfrontBaseUrl = process.env.VUE_APP_CLOUD_FRONT;
const TicketCategory = Object.freeze({
  UNUSED: 'UNUSED',
  EXPIRED: 'EXPIRED',
});

export default {
  name: 'TicketSection',
  components: {
    'info-popup': InfoPopup,
    Loading,
  },
  computed: {
    TicketCategory() {
      return TicketCategory;
    },
    // 篩選「可用票卷、過往票卷」
    filteredTickets() {
      const filtered = this.tickets.filter((ticket) => {
        if (this.currentCategory === TicketCategory.UNUSED) {
          return ticket.valid === true && ticket.isRedeemed === false; // 可用票卷
        } else if (this.currentCategory === TicketCategory.EXPIRED) {
          return ticket.valid === false || ticket.used > 0; // 過往票卷
        }
        return false;
      });
      return filtered.sort((a, b) => b.expiredAt - a.expiredAt);
    },
    ...mapState(['jwt']),
  },
  mounted() {
    if (this.jwt) {
      this.fetchTickets();
    } else {
      this.$router.push({
        path: `/${this.currentLanguage}/member-login/login`,
      });
    }
  },
  data() {
    return {
      loading: false,
      categories: [TicketCategory.UNUSED, TicketCategory.EXPIRED],
      currentCategory: TicketCategory.UNUSED,
      tickets: [],
      empty: false,
      displayAlert: false,
      selectedTicket: null,
    };
  },
  methods: {
    async fetchTickets() {
      if (this.jwt) {
        let response;
        this.loading = true;
        try {
          const langSetting = this.$route.params.lang === 'zh_tw' ? 'zh-tw' : this.$route.params.lang;
          response = await getUserBackpack(langSetting, this.jwt);
          const responseData = response.data.data;

          const tickets = responseData.ticket.list;

          if (tickets.length === 0) {
            this.empty = true;
          }

          this.tickets = tickets.map((ticket) => ({
            ...ticket,
            typeText: this.getTypeText(ticket.type),
            isRedeemed: ticket.used >= ticket.quantity,
            image: `${cloudfrontBaseUrl}/Image/Public/ticket/${ticket.id}.jpg`,
            description: ticket.description?.[0]?.content,
          }));
        } catch (error) {
          // TODO: error handling
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },
    getTypeText(type) {
      const map = {
        0: this.$t('ticket-section.key013'),
        1: this.$t('ticket-section.key014'),
        2: this.$t('ticket-section.key015'),
        3: this.$t('ticket-section.key016'),
      };
      return map[type] || '';
    },
    changeCategory(category) {
      this.currentCategory = category;
    },
    goToUsage(ticketId) {
      document.body.style.overflow = 'hidden';
      this.selectedTicket = this.filteredTickets.find((ticket) => ticket.id === ticketId);
      this.$emit('show-info-popup');
    },
    closeInfoPopup() {
      document.body.style.overflow = '';
      this.selectedTicket = null;
    },
    showAlert() {
      document.body.style.overflow = 'hidden';
      this.displayAlert = true;
    },
    hideAlert() {
      document.body.style.overflow = '';
      this.displayAlert = false;
    },
  },
};
</script>
